import Layout from '@/components/Layout'
import Meta from '@/components/Meta'
import Okta from '@/components/Okta/index'
import { getRedirectUrlOnSignInComplete } from '@/components/Okta/utils/util'
import DEFAULT_META_TAGS from '@/constants/meta'
import useCanonicalUrl from '@/hooks/useCanonicalUrl'
import useRedirectUrl from '@/hooks/useRedirectUrl'
import mapSetiResponse from '@/shared-utils/map-seti-response'
import type { CustomContext, PageProps } from '@/types'
import CONFIG from 'isomorphic-config'
import { type GetServerSideProps } from 'next'
import setiService from '../../server/middleware/seti'
import oktaJwtVerify from '../../server/utils/okta-jwt-verifier'
import fetchPCLNHeaderFooterContent from '../../server/utils/pcln-header-footer'
import generateBootstrapData from '../../utils/generate-bootstrap-data'

function Join({ headerHTML, footerHTML, bootstrapData }: PageProps) {
  const { isMobile } = bootstrapData
  const clientScope = isMobile ? 'mobileweb' : 'desktop'

  const issuer = `https://${CONFIG.client.okta.domain}/oauth2/default`
  const callbackUrl = `/home/join/login/callback`

  const oktaClientId = CONFIG.client.okta.clientId

  const canonicalUrl = useCanonicalUrl()
  const redirectUrl = useRedirectUrl()
  if (typeof window !== 'undefined') {
    window.addEventListener('SIGN_IN_COMPLETE', () => {
      // eslint-disable-next-line react-hooks/immutability
      window.location.href = getRedirectUrlOnSignInComplete(redirectUrl, document.baseURI)
    })
  }
  return (
    <>
      <Meta
        description={DEFAULT_META_TAGS.description.join}
        pageTitle={DEFAULT_META_TAGS.title.join}
        canonicalUrl={canonicalUrl}
        noIndex
      />
      <Layout headerHTML={headerHTML} footerHTML={footerHTML}>
        <Okta
          redirectUrl={redirectUrl}
          clientId={oktaClientId}
          issuer={issuer}
          callbackUrl={callbackUrl}
          clientScope={clientScope}
        />
      </Layout>
    </>
  )
}

export const getServerSideProps: GetServerSideProps<PageProps> = async (ctx) => {
  const { req, res } = ctx as CustomContext
  const bootstrapData = generateBootstrapData({ product: 'join', req, res })
  const { webstats, referral, appVersion } = bootstrapData
  const { clientGUID: cguid } = webstats

  const [pclnHeaderFooterContent, signInStatus] = await Promise.all([
    fetchPCLNHeaderFooterContent(req, res),
    oktaJwtVerify({ authHdr: req.headers.authorization ?? '', cguid }),
  ])

  const setiResponseEvents = await setiService(req, {
    appVersion,
    allowSetiOverrides: true,
    webstats,
    referral,
    reqQueryParams: ctx.query,
  })

  const bootstrapWithJwtSignInData = {
    ...bootstrapData,
    customer: {
      signedIn: signInStatus.signedIn ?? false,
      emailAddress: signInStatus.email ?? '',
      firstName: String(signInStatus.firstName ?? ''),
    },
  }

  return {
    props: {
      headerHTML: pclnHeaderFooterContent.headerHTML,
      footerHTML: '',
      bootstrapData: {
        ...bootstrapWithJwtSignInData,
        fullSETI: setiResponseEvents,
        seti: mapSetiResponse(setiResponseEvents),
        signInStatus,
      },
    },
  }
}

export default Join
